module.exports = __webpack_public_path__ + "static/img/1.dce8e24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/1.png
// module id = YG+R
// module chunks = 0